import React from "react";

import "./styles.scss";

const Notification = ({ message, icon }) => {
  return <div className="Notification">{message}</div>;
};

export default Notification;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/Notification/index.js